import "./NavBar.css";

import LinkedInIcon from "@mui/icons-material/LinkedIn";
import AccountTreeIcon from "@mui/icons-material/AccountTree";

import config from "../../config.json";
import { GitHub } from "@mui/icons-material";

const NavBar = () => {
	return (
		<header>
			<nav>
				<section>
					<h1>Callum Stevenson</h1>
					<span className="hint">.NET Developer</span>
				</section>
				<section>
					<a
						className="nav-link"
						target="_blank"
						href={config.links.linkedin}
					>
						<LinkedInIcon
							style={{
								fill: "#fff",
								fontSize: "40px",
							}}
						/>
					</a>
					<a
						className="nav-link"
						target="_blank"
						href={config.links.ado}
					>
						<AccountTreeIcon
							style={{
								fill: "#fff",
								fontSize: "40px",
							}}
						/>
					</a>
					<a
						className="nav-link"
						target="_blank"
						href={config.links.github}
					>
						<GitHub
							style={{
								fill: "#fff",
								fontSize: "40px",
							}}
						/>
					</a>
				</section>
			</nav>
		</header>
	);
};

export default NavBar;
